const TOKEN_KEY = 'admin_token'
const EXPIRES_KEY = 'admin_token_expires'
const MENUS_KEY = 'admin_menus'
const AUTHS_KEY = 'admin_auths'
const USER_KEY = 'admin_username'
const PROFILE_KEY = 'admin_user_profile'

function safeJson(raw, fallback) {
  try {
    return raw ? JSON.parse(raw) : fallback
  } catch {
    return fallback
  }
}

export function readPersistedSession() {
  const profile = safeJson(localStorage.getItem(PROFILE_KEY), null)
  const legacyName = localStorage.getItem(USER_KEY)
  let user = null
  if (profile && (profile.username || profile.realName)) {
    user = {
      username: profile.username || '',
      realName: profile.realName || '',
      name: profile.realName || profile.username || '管理员'
    }
  } else if (legacyName) {
    user = { name: legacyName, username: legacyName, realName: '' }
  }
  return {
    token: localStorage.getItem(TOKEN_KEY) || '',
    tokenExpires: Number(localStorage.getItem(EXPIRES_KEY)) || 0,
    menus: safeJson(localStorage.getItem(MENUS_KEY), []),
    auths: safeJson(localStorage.getItem(AUTHS_KEY), []),
    user
  }
}

export function persistUserProfile({ username, realName }) {
  localStorage.setItem(
    PROFILE_KEY,
    JSON.stringify({
      username: username || '',
      realName: realName || ''
    })
  )
}

export function clearUserProfile() {
  localStorage.removeItem(PROFILE_KEY)
}

export function persistSession({ token, tokenExpires, menus, auths, username }) {
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(EXPIRES_KEY, String(tokenExpires || ''))
  localStorage.setItem(MENUS_KEY, JSON.stringify(menus || []))
  localStorage.setItem(AUTHS_KEY, JSON.stringify(auths || []))
  if (username) localStorage.setItem(USER_KEY, username)
}

export function clearPersistedSession() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(EXPIRES_KEY)
  localStorage.removeItem(MENUS_KEY)
  localStorage.removeItem(AUTHS_KEY)
  localStorage.removeItem(USER_KEY)
  localStorage.removeItem(PROFILE_KEY)
}
